import { CLOSE_NOTIFICATION, DISPLAY_NOTIFICATION, PERMISSION_TOAST_AUTO_DISMISS_MS } from 'notification/constants';

export const displayNotification = (msgText, notificationType, showCloseBtn, id, delayTime, autoDismissTime, isPermissionToast) => ({
  type: DISPLAY_NOTIFICATION,
  msgText,
  notificationType,
  showCloseBtn,
  id,
  timestamp: Date.now(),
  delayTime,
  autoDismissTime,
  isPermissionToast,
});

export const displayPermissionToast = (msgText, id) => displayNotification(msgText, 'warning', true, `${id}-${Date.now()}`, 0, PERMISSION_TOAST_AUTO_DISMISS_MS, true);

export const closeNotification = (id) => ({ type: CLOSE_NOTIFICATION, id });

export const handleNotification = (msgText, type, showCloseBtn, autoClose) => {
  const min = 10000;
  const max = 0;
  const rnd = min + Math.random() * (max - min);

  return (dispatch) => {
    dispatch(displayNotification(msgText, type, showCloseBtn, rnd, 0));
    if (autoClose) setTimeout(() => void dispatch(closeNotification(rnd)), 5000);
  };
};
